import Error from '@core/components/Error/Error';
import Meta from '@core/components/Meta/Meta';
import { useAddTranslations } from '@core/hooks/useAddTranslations';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { trans } from './local';

const NotFound = (): React.ReactElement | null => {
  const { t } = useTranslation();
  useAddTranslations(trans);
  return (
    <>
      <Meta title={t('notFound.metaTitle')} description={t('notFound.metaDescription')} noTrack />
      <Error title={t('notFound.title')} description={t('notFound.description')} logo homeButton />
    </>
  );
};

export default NotFound;
